import React from "react";
import "./styles.scss";
import Card1 from "../Card1";
import Card2 from "../Card2";
import Card3 from "../Card3";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Pagination } from "swiper";
export default function ContentModal() {
  const pagination = {
    clickable: true,
    renderBullet: function (_, className) {
      return `<span class="${className}"></span> `;
    },
  };

  return (
    <div className="wrap-content-modal">
      <div className="content-modal-desktop">
        <Card1 />
        <Card2 />
        <Card3 />
      </div>

      <div className="content-modal-mobile">
        <Swiper
          pagination={pagination}
          effect={"fade"}
          modules={[EffectFade, Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <Card1 />
          </SwiperSlide>
          <SwiperSlide>
            <Card2 />
          </SwiperSlide>
          <SwiperSlide>
            <Card3 />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}
